import React from 'react';
import { Card, Form, Row, Col, Input } from 'antd';
import { Company } from '../../../../types/company.types';

interface TaxInfoFormProps {
  form: ReturnType<typeof Form.useForm>[0];
  companyData: Partial<Company>;
  loading: boolean;
}

const TaxInfoForm: React.FC<TaxInfoFormProps> = ({ form, companyData, loading }) => (
  <Card className="setting-card" title="Vergi Bilgileri">
    <Row gutter={[16, 16]}>
      <Col xs={24} sm={12}>
        <Form.Item
          label="Vergi Numarası"
          name="taxNumber"
          initialValue={companyData.taxNumber}
          rules={[{ required: true, message: 'Vergi numarası zorunludur' }]}
        >
          <Input size="large" placeholder="Vergi numarasını giriniz" disabled={loading} />
        </Form.Item>
      </Col>
      <Col xs={24} sm={12}>
        <Form.Item
          label="Vergi Dairesi"
          name="taxOffice"
          initialValue={companyData.taxOffice}
          rules={[{ required: true, message: 'Vergi dairesi zorunludur' }]}
        >
          <Input size="large" placeholder="Vergi dairesini giriniz" disabled={loading} />
        </Form.Item>
      </Col>
    </Row>
  </Card>
);

export default TaxInfoForm;
